import { RemoteAmendSmartcard } from "../../../../data/usecases/smartcard";
import { AmendSmartcard } from "../../../../domain/usecases/amend-smartcard";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteAmendSmartcard = (): AmendSmartcard =>
  new RemoteAmendSmartcard(
    makeApiUrl("/smartcards/amend-smartcard"),
    makeAxiosHttpClient()
  );
